import { Badge } from '../../components/ui/badge';
import { Button } from '../../components/ui/button';
import {
  ScanBarcode, Usb, Unplug, Printer, Monitor, MonitorOff,
  DoorOpen, ScanLine, ListRestart,
} from 'lucide-react';
import { isWebSerialSupported } from '../../lib/hardwareService';

export const POSHardwareBar = ({
  printerConnected, displayOpen, heldCount,
  onTogglePrinter, onToggleDisplay, onOpenDrawer, onOpenRxScanner, onOpenHeldSales,
}) => (
  <div className="flex items-center gap-2 mb-3 px-1 flex-wrap" data-testid="hardware-bar">
    <Badge variant="outline" className="text-[10px] gap-1 cursor-default">
      <ScanBarcode className="h-3 w-3 text-green-500" /> Scanner Ready
    </Badge>
    {isWebSerialSupported() ? (
      <Button variant="outline" size="sm" className="h-7 text-[11px] gap-1.5" onClick={onTogglePrinter} data-testid="printer-toggle-btn">
        {printerConnected
          ? <><Usb className="h-3 w-3 text-green-500" /> Printer Connected</>
          : <><Unplug className="h-3 w-3 text-muted-foreground" /> Connect Printer</>}
      </Button>
    ) : (
      <Badge variant="outline" className="text-[10px] gap-1 text-muted-foreground cursor-default">
        <Printer className="h-3 w-3" /> Browser Print
      </Badge>
    )}
    <Button variant="outline" size="sm" className="h-7 text-[11px] gap-1.5" onClick={onToggleDisplay} data-testid="display-toggle-btn">
      {displayOpen
        ? <><Monitor className="h-3 w-3 text-green-500" /> Display On</>
        : <><MonitorOff className="h-3 w-3 text-muted-foreground" /> Customer Display</>}
    </Button>
    {printerConnected && (
      <Button variant="outline" size="sm" className="h-7 text-[11px] gap-1.5" onClick={onOpenDrawer} data-testid="cash-drawer-btn">
        <DoorOpen className="h-3 w-3" /> Open Drawer
      </Button>
    )}
    <Button
      variant="outline"
      size="sm"
      className="h-7 text-[11px] gap-1.5"
      onClick={onOpenRxScanner}
      title="Open the AI Rx Scanner — extract medications from a prescription image"
      data-testid="open-rx-scanner-btn"
    >
      <ScanLine className="h-3 w-3 text-primary" /> Rx Scanner
    </Button>
    <Button
      variant="outline"
      size="sm"
      className="h-7 text-[11px] gap-1.5 ml-auto"
      onClick={onOpenHeldSales}
      data-testid="open-held-sales-btn"
    >
      <ListRestart className="h-3 w-3 text-primary" /> Recall
      {heldCount > 0 && (
        <Badge variant="secondary" className="h-4 px-1.5 text-[10px] tabular-nums" data-testid="held-sales-count-badge">
          {heldCount}
        </Badge>
      )}
    </Button>
  </div>
);
